import React from "react";

import RSVPTitle from "./RSVPTitle";

const RsvpDone = () => {

  return <>
    <div class="row">
      <div class="col">
        <div className="card-b-1">
            <RSVPTitle>Thank you. Your RSVP has been sent.</RSVPTitle>
        </div>
      </div>
    </div>
  </>;
}

export default RsvpDone;
